<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.83843 5.57042C10.527 5.57042 11.3902 5.10743 11.9042 4.49012C12.3697 3.93068 12.7091 3.14939 12.7091 2.3681C12.7091 2.262 12.6994 2.1559 12.68 2.06909C11.9139 2.09803 10.9925 2.5803 10.4397 3.22656C10.0033 3.71848 9.60567 4.49012 9.60567 5.28105C9.60567 5.3968 9.62507 5.51254 9.63477 5.55113C9.68326 5.56077 9.76084 5.57042 9.83843 5.57042ZM7.41386 17.2415C8.35459 17.2415 8.77162 16.6145 9.94511 16.6145C11.138 16.6145 11.3999 17.2222 12.4473 17.2222C13.4753 17.2222 14.1639 16.277 14.8136 15.351C15.541 14.29 15.8417 13.2483 15.8611 13.2C15.7932 13.1807 13.8244 12.3802 13.8244 10.1328C13.8244 8.18436 15.3761 7.30661 15.4634 7.23909C14.4354 5.77297 12.874 5.73439 12.4473 5.73439C11.2932 5.73439 10.3524 6.42887 9.76084 6.42887C9.12076 6.42887 8.27701 5.77297 7.27808 5.77297C5.37722 5.77297 3.44727 7.33555 3.44727 10.2871C3.44727 12.1197 4.16494 14.0585 5.04748 15.3124C5.80395 16.3734 6.46343 17.2415 7.41386 17.2415Z"
    fill="currentColor"
  />
</svg>
